import "../phone_validation.js"
import "../field-error.js"

/* global Stimulus */

window.stimulusApp.register(
  "phone-field",
  class extends Stimulus.Controller {
    static targets = ["countrySelect", "phoneInput", "flagImage", "countryCode"]
    static values = { invalidMessage: String }

    countryChanged(event) {
      const selectedOption = event.target.selectedOptions[0]
      const callingCode = selectedOption.dataset.callingCode
      const flagPath = selectedOption.dataset.flagPath

      if (callingCode) {
        if (this.hasFlagImageTarget && flagPath) {
          this.flagImageTarget.src = flagPath
          this.flagImageTarget.classList.remove("hidden")
        } else if (this.hasFlagImageTarget) {
          this.flagImageTarget.classList.add("hidden")
        }

        if (this.hasCountryCodeTarget) {
          this.countryCodeTarget.textContent = callingCode
        }

        if (this.phoneInputTarget.value) {
          this.#updateValidationState()
        }

        // Skip on iOS to avoid keyboard issues
        if (!this.#isIOS()) {
          this.#focusAndMoveCursor()
        }
      }
    }

    checkFormat(event) {
      if (event.data === null) {
        return
      }

      if (!/^\d+$/.test(event.data)) {
        event.preventDefault()
        event.stopImmediatePropagation()
      }
    }

    inputBlurred() {
      this.#updateValidationState()
    }

    inputChanged() {
      this.#updateValidationState()
    }

    inputFocused() {
      this.#moveCursorToEnd()
    }

    #updateValidationState() {
      const phone =
        this.countryCodeTarget.textContent + this.phoneInputTarget.value
      const isInvalid = !window.HB.validatePhone(phone)

      if (isInvalid) {
        window.HB.showFieldError(
          this.phoneInputTarget,
          this.invalidMessageValue,
        )
      } else {
        window.HB.clearFieldError(this.phoneInputTarget)
      }
    }

    #focusAndMoveCursor() {
      if (this.phoneInputTarget) {
        this.phoneInputTarget.focus()
        this.#moveCursorToEnd()
      }
    }

    #moveCursorToEnd() {
      const inputLength = this.phoneInputTarget.value.length * 2

      // setTimeout needed for Chrome focus bug
      setTimeout(() => {
        this.phoneInputTarget.setSelectionRange(inputLength, inputLength)
      }, 0)
    }

    #isIOS() {
      return document.documentElement.classList.contains("ios")
    }
  },
)
